import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";

export const ScrollNav = () => {
  const [pos, setPos] = useState("top");
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setPos(y < 300 ? "top" : max - y < 300 ? "bottom" : "mid");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const go = (top) => window.scrollTo({ top, behavior: "smooth" });
  const btn = "w-10 h-10 md:w-11 md:h-11 grid place-items-center bg-[#111] text-[#FDD105] hover:bg-[#FDD105] hover:text-[#111] transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FDD105]";
  return (
    <div className="fixed right-4 md:right-6 bottom-24 md:bottom-auto md:top-1/2 md:-translate-y-1/2 z-[55] md:z-[90] hidden min-[1400px]:flex flex-col rounded-full overflow-hidden shadow-[0_18px_40px_-16px_rgba(0,0,0,0.6)] ring-1 ring-black/10" data-testid="scroll-nav">
      {pos !== "top" && <button type="button" onClick={() => go(0)} aria-label="Nach oben" title="Nach oben" className={btn} data-testid="scroll-to-top"><ArrowUp size={18} /></button>}
      {pos !== "bottom" && <button type="button" onClick={() => go(document.documentElement.scrollHeight)} aria-label="Nach unten" title="Nach unten" className={`${btn} ${pos === "mid" ? "border-t border-white/10" : ""}`} data-testid="scroll-to-bottom"><ArrowDown size={18} /></button>}
    </div>
  );
};
